import React, { useState } from 'react';
import { Lightbulb, X, ChevronDown, ChevronUp } from 'lucide-react';

export const SmartSuggestion = ({ suggestion, onDismiss }) => {
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(true);

  if (!suggestion?.has_suggestion || !visible) return null;

  const typeColors = {
    healthier_swap: { bg: 'bg-[#6B9E8A]/10', text: 'text-[#6B9E8A]' },
    protein_boost: { bg: 'bg-[#4A90D9]/10', text: 'text-[#4A90D9]' },
    portion_awareness: { bg: 'bg-[#E5A84B]/10', text: 'text-[#E5A84B]' },
    balance_nudge: { bg: 'bg-[#D4736A]/10', text: 'text-[#D4736A]' },
    positive_reinforcement: { bg: 'bg-[#6B9E8A]/10', text: 'text-[#6B9E8A]' },
    hydration_reminder: { bg: 'bg-[#4A90D9]/10', text: 'text-[#4A90D9]' },
    cooking_method_tip: { bg: 'bg-[#E5A84B]/10', text: 'text-[#E5A84B]' },
  };

  const colors = typeColors[suggestion.type] || typeColors.positive_reinforcement;

  return (
    <div
      data-testid="smart-suggestion"
      className={`rounded-2xl overflow-hidden transition-all duration-300 ${colors.bg} border border-current/5`}
    >
      <div
        data-testid="suggestion-toggle"
        onClick={() => setExpanded(!expanded)}
        className="w-full p-4 flex items-center gap-3 text-left cursor-pointer"
        role="button"
        tabIndex={0}
      >
        <Lightbulb className={`w-5 h-5 flex-shrink-0 ${colors.text}`} />
        <span className={`flex-1 text-sm font-medium ${colors.text}`}>
          {suggestion.teaser}
        </span>
        <div className="flex items-center gap-1">
          {expanded ? (
            <ChevronUp className={`w-4 h-4 ${colors.text} opacity-60`} />
          ) : (
            <ChevronDown className={`w-4 h-4 ${colors.text} opacity-60`} />
          )}
          <span
            data-testid="dismiss-suggestion"
            role="button"
            tabIndex={0}
            onClick={(e) => { e.stopPropagation(); setVisible(false); onDismiss?.(); }}
            className="p-1 rounded-full hover:bg-black/5 dark:hover:bg-white/5 cursor-pointer"
          >
            <X className={`w-3.5 h-3.5 ${colors.text} opacity-40`} />
          </span>
        </div>
      </div>

      {expanded && (
        <div className="px-4 pb-4 -mt-1 animate-fade-in-up">
          <p className={`text-sm ${colors.text} opacity-90 leading-relaxed pl-8`}>
            {suggestion.full_suggestion}
          </p>
          {suggestion.calorie_impact > 0 && (
            <div className="mt-2 pl-8">
              <span className="text-xs font-semibold text-[#C67A5C] bg-[#C67A5C]/10 px-2 py-1 rounded-full">
                Could save ~{suggestion.calorie_impact} cal
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
